module.exports = __webpack_public_path__ + "static/media/folk_temp.aa1c7ac5.jpg";